export default __webpack_public_path__ + "static/media/credit_card_1.10da9630.png";